import { IResponse } from "models";

export enum ActionType {
  VERIFY_PHONE_NUMBER = "action/VERIFY_PHONE_NUMBER",
  VERIFY_PHONE_NUMBER_SUCCESS = "action/VERIFY_PHONE_NUMBER_SUCCESS",
  VERIFY_PHONE_NUMBER_ERROR = "action/VERIFY_PHONE_NUMBER_ERROR",
  VERIFY_PHONE_NUMBER_RESET = "action/VERIFY_PHONE_NUMBER_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IVerifyPhoneNumberPayload {
  mobile_number: string;
  super_city_code: string;
}

export interface IVerifyPhoneNumberResponse extends IResponse {
  result: any;
}
